// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Form, Button } from "react-bootstrap";

// const SearchBox = () => {
//   let navigate = useNavigate();
//   const [keyword, setKeyword] = useState("");

//   const submitHandler = (e) => {
//     e.preventDefault();
//     if (keyword.trim()) {
//       navigate(`/search/${keyword}`);
//     } else {
//       navigate("/");
//     }
//   };

//   return (
//     <Form onSubmit={submitHandler} className="d-flex" >
//       <Form.Control
//         type="text"
//         name="keyword"
//         placeholder="Search products ..."
//         onChange={(e) => setKeyword(e.target.value)}
//         className="mr-sm-2 ml-sm-5"
//       ></Form.Control>
//       <Button variant="info" type="submit" className="p-0.5">
//         Search
//       </Button>
//     </Form>
//   );
// };

// export default SearchBox;



import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Modal } from "react-bootstrap";

const SearchBox = () => {
  let navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [showModal, setShowModal] = useState(false);

  const submitHandler = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      navigate(`/search/${keyword}`);
      setShowModal(false);
      setKeyword("");
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setKeyword("");
  };

  
  return (
    <>
      {/* Search Icon Button */}
      <button
        onClick={() => setShowModal(true)}
        className="search-icon-btn"
        aria-label="Search products"
      >
        <i className="fas fa-search"></i>
      </button>

      {/* Search Modal */}
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className="search-modal"
      >
        <Modal.Body>
          <button onClick={handleClose} className="search-close-btn" aria-label="Close search">
            <i className="fas fa-times"></i>
          </button>
          
          <div className="search-modal-content">
            <h3 className="search-modal-title">Search Products</h3>
            
            <Form onSubmit={submitHandler}>
              <div className="search-input-wrapper">
                <i className="fas fa-search search-input-icon"></i>
                <Form.Control
                  type="text"
                  name="keyword"
                  placeholder="What are you looking for?"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  className="search-modal-input"
                  autoFocus
                />
              </div>
              
              <Button 
                variant="primary" 
                type="submit" 
                className="search-modal-btn"
                disabled={!keyword.trim()}
              >
                Search
              </Button>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SearchBox;
